import { render, staticRenderFns } from "./hotmoreVideo.vue?vue&type=template&id=2cd3d1e0&scoped=true"
import script from "./hotmoreVideo.vue?vue&type=script&lang=js"
export * from "./hotmoreVideo.vue?vue&type=script&lang=js"
import style0 from "./hotmoreVideo.vue?vue&type=style&index=0&id=2cd3d1e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3d1e0",
  null
  
)

export default component.exports